import classnames from 'classnames';
import 'src/styles/icon/css/stratec-farois.css';
import 'src/styles/icon/css/stratec-modulos.scss';
import css from 'src/utils/css';
import 'src/styles/icon/css/icons.scss';
import LucideIcon from '../lucide-icon';

const BADGE_COLORS = {
  check: '#8bc53f',
  exclamation: '#ec1c24',
};

export default function SvgIcon(props) {
  let {
    className,
    size = 18,
    color,
    colorHover,
    icon,
    title,
    iconBadge,
    metaIconFontsize = 13,
    ehRelacionamento,
    ...other
  } = props;

  const baseClasses = css`
    .container {
      display: inline-block;
      vertical-align: middle;
      position: relative;
      width: 25px;
    }
  `;

  const classes = css`
    .container {
      font-size: ${size ? size + 'px' : 'inherit'};
      color: ${color || 'inherit'};
      &:hover {
        color: ${colorHover || 'inherit'};
      }
    }
  `.extend(baseClasses);

  let styleInline = {
    color: `${color}`,
    width: `${ehRelacionamento ? 22 + 'px' : size ? size + 'px' : 'inherit'}`,
    height: `${size ? size + 'px' : 'inherit'}`,
    backgroundSize: `${size ? size + 'px' : 'inherit'}`,
    display: 'inline-block',
    linHeight: 1,
    content: ' ',
  };

  const mainIcon = `icon icon-${icon}`;

  return (
    <div {...other} className={classnames(classes.container, className)} title={title}>
      {iconBadge && (
        <LucideIcon
          icon={iconBadge}
          size={metaIconFontsize}
          color={BADGE_COLORS[iconBadge] || color}
          className="meta-icon"
        />
      )}
      <i style={styleInline} className={mainIcon}></i>
    </div>
  );
}
